import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'catimg'
})
export class CatimgPipe implements PipeTransform {

  transform(imgname: string, files: any[]): string {
    var retval = ''
    files.filter(f => f.name == imgname).forEach(f => {
      retval = f.data
    })
    return 'url(data:image/jpg;base64,' + retval + ')'
  }

}
